import React from "react";
import Checkbox from "@/Components/Checkbox";
import {Error} from "@/Components/Error";
import classNames from "classnames";

export default function CheckboxInput(props) {
    const formItemCheckbox = classNames('formItemCheckbox', props.className, {});

    return (
        <div className={formItemCheckbox}>
            <Checkbox {...props} />
            <Error {...props} />
        </div>
    );
}
